<div>
  <div class="row navigation-container">
    <span (click)="navigateBack()" class="back-btn">
      <em class="fas fa-caret-left mx-2"></em>
      <span class="m-1">{{ 'MAIN.BACK' | translate }}</span>
    </span>
    <div class="row" [ngClass]="isMobile ? 'mx-1' : 'mx-4'">
      <span (click)="routeTo(homeRoute)" class="mx-2 nav-text navigation-link">
        <em class="fas fa-home"></em>
      </span>

      <span *ngFor="let breadcrumb of breadcrumbs">
        <em *ngIf="breadcrumb.show" class="fas fa-caret-right mx-4 mt-1"></em>
        <span
          *ngIf="!breadcrumb.isLast || breadcrumb.show; else lastBreadcrumb"
          (click)="routeTo(breadcrumb.absoluteRoute)"
          class="navigation-link"
          >{{
            (isMobile && breadcrumb.shortTitle
              ? breadcrumb.shortTitle
              : breadcrumb.title
            ) | translate
          }}
          <span
            *ngIf="
              breadcrumb.subTitle &&
              breadcrumb.subTitle !== BreadcrumbTitleEnum.Empty
            "
          >
            - {{ breadcrumb.subTitle }}
          </span>
        </span>
        <ng-template #lastBreadcrumb>
          <span class="mx-1"
            >{{
              (isMobile && breadcrumb.shortTitle
                ? breadcrumb.shortTitle
                : breadcrumb.title
              ) | translate
            }}
            <span *ngIf="breadcrumb.subTitle">
              - {{ breadcrumb.subtitle }}
            </span></span
          >
        </ng-template>
      </span>
    </div>
  </div>
</div>
